'use client';

interface MenuToggleProps {
  isOpen: boolean;
  setOpen: () => void;
}

// 햄버거 토글 — CSS-only (열림 시 3줄 → X 애니메이션). 파란 GNB 위라 흰색 바.
export default function MenuToggle({ isOpen, setOpen }: MenuToggleProps) {
  return (
    <button
      type="button"
      onClick={setOpen}
      aria-label={isOpen ? '메뉴 닫기' : '메뉴 열기'}
      aria-expanded={isOpen}
      className="relative flex size-10 cursor-pointer flex-col items-center justify-center gap-[5px]"
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          aria-hidden
          className="h-[2px] w-6 rounded-full bg-white transition-transform duration-300 ease-linear"
          style={{
            transform: isOpen
              ? i === 0
                ? 'translateY(7px) rotate(45deg)'
                : i === 1
                  ? 'scaleX(0)'
                  : 'translateY(-7px) rotate(-45deg)'
              : 'none',
          }}
        />
      ))}
    </button>
  );
}
